import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/user/cep",

        async search(zip) {
            const address = await Vue.http.get(this.url(`/${zip}`));

            return {
                streetName: address.logradouro,
                neighborhood: address.bairro,
                city: address.localidade,
                state: address.uf
            };
        }
    },
    base
);
